"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var margin_1 = __importDefault(require("../Utils/margin"));
var padding_1 = __importDefault(require("../Utils/padding"));
exports.default = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  display: flex;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  display: flex;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), margin_1.default, padding_1.default, function (_a) {
    var wrap = _a.wrap;
    return wrap && "flex-wrap: ".concat(wrap, ";");
}, function (_a) {
    var direction = _a.direction;
    return direction && "flex-direction: ".concat(direction, ";");
}, function (_a) {
    var alignContent = _a.alignContent;
    return alignContent && "align-content: ".concat(alignContent, ";");
}, function (_a) {
    var alignItems = _a.alignItems;
    return alignItems && "align-items: ".concat(alignItems, ";");
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent && "justify-content: ".concat(justifyContent, ";");
});
var templateObject_1;
// TODO Flex item
